import elements from "./elements";
class segments {
      constructor(
            scheduleId,
            segmId,
            sequenceNumber,
            segment,
            days,
            despl,
            typeJor,
            elements) {
        this.scheduleId = scheduleId;
        this.segmId=segmId
        this.sequenceNumber = sequenceNumber;
        this.name=segment
        this.days = days
        this.despl = despl
        this.typeJor=typeJor
        this.elements=elements
      }
      static fromJson({ 
            horarioId,
            segmId,
            numSecuencia,
            nomSegm,
            dias,
            desplJornada,
            tipoJornada,
            elems
})

 {
        return new segments(
            horarioId,
            segmId,
            numSecuencia,
            nomSegm,
            dias,
            desplJornada,
            tipoJornada,
            elems?.map((e)=>elements.fromJson(e))
            );
      }
    }
    export default segments;
    